<template>
  <div class="about list-details list-light texture-light-bg-css">
    <div class="w">
      <div class="page-header">
        <Breadcrumb ref="breadcrumb" class="deep-breadcrumb" />
      </div>

      <div class="text-center content-title">
        <span class="inline-block title-font">{{ fontTitle }}</span>
      </div>

      <div class="text-center light-flower-bg relative cursor-default">
        <!-- <MarkdownViewer
          class="about-content"
          v-if="tabContent"
          :emptyText="'暂无数据'"
          :content="tabContent"
        ></MarkdownViewer> -->
        <HtmlViewer
          class="about-content"
          :emptyText="'暂无数据'"
          :content="tabContent"
        ></HtmlViewer>
      </div>
    </div>
  </div>
</template>

<script>
import link from '@/core/mixins/link'
import Breadcrumb from '@/components/common/Breadcrumb'
// import MarkdownViewer from '@/components/common/MarkdownViewer'
import HtmlViewer from '@/components/common/HtmlViewer'
import { getPage } from '@/core/api'
export default {
  name: 'about',
  mixins: [link],
  components: {
    Breadcrumb,
    HtmlViewer
  },
  data() {
    return {
      id: 'survey', // 一进页面显示第一个'御窑概况'
      tabContent: null
    }
  },
  watch: {
    '$route.fullPath'() {
      this.initPageData()
    }
  },
  computed: {
    fontTitle() {
      let category = this.$route.params.category || this.$route.meta.id // 从地址栏拿栏目的ID
      let breadcrumb = this.$store.getters['CategoriesStore/breadcrumb'](
        category
      )
      return breadcrumb[breadcrumb.length - 1].title
    }
  },
  mounted: function() {
    this.initPageData()
  },
  methods: {
    initPageData() {
      this.id = this.$route.params.category // 从地址栏拿栏目的ID
      this.getCategoryPage()
    },
    async getCategoryPage() {
      let res = await getPage(this.id)
      if (res.status === 200) {
        // console.log(res) // eslint-disable-line no-console
        this.tabContent = res.data.html
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.about {
  padding-bottom: 80px;
  .about-content {
    line-height: 2.1;
    font-size: 16px;
    color: $c-breadcrumb-deep-font;
    text-align: left;
    padding: 60px 85px;
    margin-bottom: 80px;
    margin-top: 30px;
    // ::v-deep  .paragraph {
    //   padding-bottom: 34px;
    //   &:last-child {
    //     padding-bottom: 0;
    //     text-align: right;
    //   }
    // }
  }

  .about-content.text-center {
    text-align: center;
  }
}
</style>
